import { Row } from 'antd';
import { useAppSelector, useAppTranslation } from 'app/hooks';
import React from 'react';
import { selectPlatforms } from 'redux/casinoSlice';
import PlatformCard from './PlatformCard';
export interface PlatContainerProps {}

const PlatformContainer: React.FC<PlatContainerProps> = ({}) => {
  const platforms = useAppSelector(selectPlatforms);

  const t = useAppTranslation();

  return (
    <div className="casino-game-list">
      <Row className="relative" gutter={[10, 8]} wrap={true}>
        {!!platforms.length &&
          platforms.map((platform, index) => (
            <PlatformCard
              tag={index === 0 ? t('casino.dailyWin') : undefined}
              platform={platform}
            />
          ))}
      </Row>
    </div>
  );
};

export default PlatformContainer;
